
import toast from 'react-hot-toast';
import { setLoading } from "../../slices/AuthSlice";
import { message } from "../../messages/Message";
import { apiConnector } from "../apiConnector";
import { endpoints } from "../../services/api";
const {
  VIEW_RESUME_API,
  UPLOAD_API,
  GET_RESUMES_API,
  GET_SKILL_LIST_API,
  GET_INDUSTRIES_LIST_API,
  GET_COMPANIES_LIST_API,
GET_LOCATION,DOWNLOAD_API,
CREATE_NOTES,
GET_NOTES,
GET_NOTIFICATIONS,
MARK_AS_READ_NOTIFICATION,
SAVE_SEARCH_API,GET_SAVE_SEARCH} = endpoints;



export function upload(token, formData, setIsUploading,handleModalClose,setTotalProgress, setSelectionCompleted, setFiles) {
  return async (dispatch) => {
    // dispatch(setLoading(true)); 
    try {
      const response = await apiConnector("POST", UPLOAD_API, formData, {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      });
      
      if (response?.status === 200) {
        // dispatch(setLoading(false));
        setTotalProgress(100)
        setIsUploading(false);
        setSelectionCompleted(false);
        setFiles([]);
        handleModalClose();
        return response.data.message
      }
    } catch (error) {
     // dispatch(setLoading(false));
     setTotalProgress(0)
      if (error?.response && error?.response?.status === 500) {
        setIsUploading(false);
        setTotalProgress(0)
        setSelectionCompleted(false);
        setFiles([]);
        handleModalClose();
        toast.error(message.errorMessage);
      }
    }
  };
}


export function getResumes(token, page, payload) {
  return async (dispatch) => {
    //dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", GET_RESUMES_API, payload, { 'Authorization': `Bearer ${token}` }, { page: page })

      if (response?.status === 200) {
        //dispatch(setLoading(false)) 
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 422) {
          
        toast.error(error.response.data.error);
      }
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}


export function getLocations(token,location) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_LOCATION, "", { 'Authorization': `Bearer ${token}` },{location:location})

      if (response?.status === 200) {
        dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
    }
  }
}


export function getSkills(token,searchQuery) {
  return async (dispatch) => {
    //dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_SKILL_LIST_API, "", { 'Authorization': `Bearer ${token}` },{search:searchQuery})

      if (response?.status === 200) {
        //dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}

export function getCompanies(token,searchQuery) {
  return async (dispatch) => {
    //dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_COMPANIES_LIST_API, "", { 'Authorization': `Bearer ${token}` },{search:searchQuery})

      if (response?.status === 200) {
       // dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}

export function getIndustries(token,searchQuery) {
  return async (dispatch) => {
   // dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_INDUSTRIES_LIST_API, "", { 'Authorization': `Bearer ${token}` },{search:searchQuery})

      if (response?.status === 200) {
        //dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}


export function downloadResume(token, payload) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", DOWNLOAD_API, payload, { 'Authorization': `Bearer ${token}` })

      if (response?.status === 201 || response?.status === 200) {
        dispatch(setLoading(false))
       // dispatch(getUserDetails(token))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 400) {
        //dispatch(getUserDetails(token))
        toast.error(error.response.data.message);
      }
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}


export function getNotification(token) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_NOTIFICATIONS, "", { 'Authorization': `Bearer ${token}` })

      if (response?.status === 200) {
        dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
    }
  }
}

export function markAsReadNotification(token) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", MARK_AS_READ_NOTIFICATION, "", { 'Authorization': `Bearer ${token}` })

      if (response?.status === 200) {
        dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
    }
  }
}


export function saveSearch(token, payload) {
  return async (dispatch) => {
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", SAVE_SEARCH_API, payload, { 'Authorization': `Bearer ${token}` })

      if (response?.status === 200) {
        dispatch(setLoading(false))
        toast.success(response.data.message)
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 401) {
          
        toast.error(error.response.data.error);
      }
      if (error?.status === 500) {
        toast.error(error.response.data.error);
      }
    }
  }
}


export function getSaveSearch(token,page) {
  return async (dispatch) => {
      dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_SAVE_SEARCH, "", { 'Authorization': `Bearer ${token}` },{page:page})

      if (response?.status === 200) {
          dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.data?.status === 401) {    
        toast.error(error.response.data.error);
      }
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }
    }
  }
}



export function createNote(token, payload) {
  return async (dispatch) => {
    //dispatch(setLoading(true))
    try {
      const response = await apiConnector("POST", CREATE_NOTES, payload, { 'Authorization': `Bearer ${token}` })

      if (response?.status === 200) {
        //dispatch(setLoading(false))
        toast.success(response.data.message)
      }
    } catch (error) {
     // dispatch(setLoading(false));
      if (error?.response?.status === 422) {

        toast.error(error.response.data.message);
      }
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }

    }
  }
}


export function getNotes(token, id) {
  return async (dispatch) => {
   // dispatch(setLoading(true))
   const url=`${GET_NOTES}/${id}`
    try {
      const response = await apiConnector("GET", url, "", { 'Authorization': `Bearer ${token}` })

      if (response?.status === 200) {
        //dispatch(setLoading(false))
        return response;
      }
    } catch (error) {
      //dispatch(setLoading(false));
      if (error?.response?.data?.status === 400) {
        return error.response;
      }
      if (error?.status === 500) {
        toast.error(message.errorMessage);
      }

    }
  }
}
